import React from 'react';
import { Card, CardBody, CardHeader, Table } from '@edgebox/react-components';

export function DetailsCard({ title, fields }: { title: string; fields: Array<{ label: string; value: React.ReactNode }> }) {
  return (
    <Card className="mb-3">
      <CardHeader>{title}</CardHeader>
      <CardBody>
        <Table bordered size="sm" className="mb-0">
          <tbody>
            {fields.map((f) => (
              <tr key={f.label}>
                <th style={{ width: '30%' }}>{f.label}</th>
                <td>{f.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}
